(function() {
    'use strict';

a3_pilot_reports.directive('flightStatus',flightStatus);

    
    
   /**
   * @memberof PilotReports
   * @ngdoc directive
   * @name flightStatus
   * @restrict EA
   * @description
   *   Implementation of flightStatus
   *
   *   Initialize the flight Status panel needs to have flight in scope
   * @example
   *   Usage:
   *   <div flight-status></div>
   * @ngInject
   */    
function flightStatus(AircaftPositionsFactory) {
     
            
            function needsSecuritySearch(){
                if($scope.aircaftPositions.PreviousEU){
                    $scope.securitySearch = false;
                }
                
                if($scope.aircaftPositions.PreviousCounty == "SWITZERLAND" 
                    ||$scope.aircaftPositions.PreviousCounty == "NORWAY"
                    ||$scope.aircaftPositions.PreviousCounty == "ICELAND"
                    ||$scope.aircaftPositions.PreviousCounty == "MONTENEGRO"){
                    $scope.securitySearch = false;
                }
                
                 if($scope.aircaftPositions.PreviousCounty == "UNITED KINGDOM" 
                    ||$scope.aircaftPositions.PreviousCounty == "FRANCE"){
                    $scope.securitySearch = true;
                }
                
                 if($scope.flight.ArrivalCountry == "TURKEY" 
                    ||$scope.flight.ArrivalCountry == "EGYPT"
                    ||$scope.flight.ArrivalCountry == "ISRAEL"
                    ||$scope.flight.ArrivalCountry == "JORDAN"
                    ||$scope.flight.ArrivalCountry == "SAUDI ARABIA"){
                    $scope.securitySearch = true;
                }
                
            }
    
    
    return {
			restrict: 'EA',
			terminal: true,
            templateUrl: 'views/directives/flightStatus.tpl.html',
			scope : false,
            link: function ($scope, element, attrs) {
                $scope.securitySearch = false;
                
                if($scope.flight && $scope.flight.FlightId){
                    $scope.aircaftPositions =  AircaftPositionsFactory.getAircaftPositionsByFlightId($scope.flight.FlightId);
                }

            }
    }
}

})();